import moment from 'moment';

import { requestGet } from '../../utils/request';

const BASE_URL = '/api/weather/v3/historical-values/fields';

export function requestPastWeather(
  fieldId,
  startDate,
  endDate,
  unitSystem = 'us',
  yearAverage = ''
) {
  const beginDate = startDate ? moment(startDate) : moment().subtract(365, 'd');
  const finalDate = endDate ? moment(endDate) : moment();
  const numbers = yearAverage.match(/\d+/);
  const numYears = numbers && numbers[0];
  const yearAverageParam = yearAverage ? `&years-averaged=${numYears}` : '';

  const variables = 'variables=precip%2Ctmax%2Ctmin';

  const start = `start-date=${beginDate.format('YYYY-MM-DD')}`;
  const end = `end-date=${finalDate.format('YYYY-MM-DD')}`;
  const dates = `${start}&${end}`;

  const pastWeatherParams = `unit-system=${unitSystem}&${variables}&${dates}&field-ids=${fieldId}`;

  return requestGet(`${BASE_URL}?${pastWeatherParams}${yearAverageParam}`, {
    mockFile: 'weather/precipitation',
  });
}
